/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import { connect } from 'react-redux'
import { colors } from '@lmc/common/constants'
import _ from 'lodash'
import LinkComponent from '../LinkComponent/LinkComponent'
import { Icon } from '../../generic/Icon'
import { css, StyleSheet } from 'aphrodite/no-important'
import videoThumbnailPlaceholder from '../../../images/videoThumbnailPlaceholder.svg'
import Description from './Description'
import { Gallery, GalleryItem } from 'components/Gallery'
import styled from 'styled-components'
import { getNominative } from 'common/utils'

export class LogTimelineRow extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isVideoOpen: false
    }
  }

  toggleVideoPopup = () => {
    this.setState({ isVideoOpen: !this.state.isVideoOpen })
  }

  renderWitnessedBy = (log) => {
    // Avoid editedBy when edited because added a picture
    const offset = log.picture1 ? 15 : 0
    const editedAt = dayjs(log.editedAt).subtract(offset, 'seconds')
    const isEdited = log.editedAt && dayjs(log.timeLogged).isBefore(editedAt)

    if (isEdited) {
      const name = _.isObject(log.editedBy && log.editedBy.name)
        ? `${log.editedBy.name.first} ${log.editedBy.name.last}`
        : log.editedBy
      return (
        <div>
          <p style={styles.editedByText}>
            {`${log.deleted ? `Removed by` : `Edited by`} ${name} on ${dayjs(
              log.editedAt
            ).format('DD-MM-YYYY')}`}
          </p>
        </div>
      )
    }
    return null
  }

  // eslint-disable-next-line react/sort-comp
  renderIcon(log, isPDF) {
    const dotStyle = {
      ...styles.dot,
      ...(!isPDF && {
        backgroundColor: log.deleted
          ? colors.grey
          : log.categoryColor || log.category.color
      }),
      ...(isPDF && { backgroundColor: 'transparent' })
    }
    const fallback =
      'https://cdn2.iconfinder.com/data/icons/business-office-14/256/5-128.png'
    const image =
      _.get(log, 'itemIcon.url') ||
      _.get(log, 'categoryIcon.url') ||
      _.get(log, 'item.icon') ||
      _.get(log, 'category.icon') ||
      fallback
    return (
      <div style={dotStyle} className="lmc-timeline-dot">
        <div
          className="lmc-dot-icon"
          style={{ background: `url(${image})`, ...styles.iconStyle }}
        />
      </div>
    )
  }

  getCarerName = (log) => {
    if (log.carerName) return log.carerName
    if (log?.loggedBy && log?.loggedBy.name)
      return `${log?.loggedBy.name.first} ${log?.loggedBy.name.last}`
    return 'Carer'
  }

  getWitnessName = (log) => {
    if (log.witnessedBy) {
      if (log.witnessedBy.name)
        return `${log.witnessedBy.name.first} ${log.witnessedBy.name.last}`
      return log.witnessedBy
    }
    return 'Carer'
  }

  renderSubHeader = (log, dateFormat) => {
    const logSavedAt = dayjs(log.originalTimeLog)
      .subtract(15, 'seconds')
      .format()
    const isTimeLogged = dayjs(log.timeLogged).format()
    const dayLogSavedTimedAt = dayjs(log.originalTimeLog).format('D')
    const dayLogChangedTimeAt = dayjs(log.timeLogged).format('D')
    const isSameDay = dayLogChangedTimeAt === dayLogSavedTimedAt

    let smallText = ''

    if (log.originalTimeLog) {
      if (logSavedAt > isTimeLogged) {
        if (isSameDay) {
          smallText += `, logged at: ${dayjs(log.originalTimeLog).format(
            'HH:mm'
          )}`
        } else {
          smallText += `, logged at: ${dayjs(log.originalTimeLog).format(
            'DD/MM/YY HH:mm'
          )}`
        }
      }
    }

    if (log.witnessedBy) {
      smallText += `, witnessed by ${this.getWitnessName(log)}`
    }

    return (
      <div style={styles.smallText} className="lmc-timeline-date">
        {dayjs(log.timeLogged).format(dateFormat || 'HH:mm')} -{' '}
        {this.getCarerName(log)}
        <span style={{ opacity: 0.7 }}>{smallText}</span>
      </div>
    )
  }

  render() {
    const { mock = false, log, dateFormat, role, testId, index } = this.props

    const isDisabled = role === 'senior-carer' || mock === true
    const isDeleted = log.deleted

    const { videoThumbnail, videoFile } = log

    const opacity = log.deleted && 0.2
    const baseId = testId
      ? `${testId}-row-${index}`
      : `log-timeline-row-${index}`

    const Popup = (props) => (
      <div className={css(classes.popupBox)}>
        <div className={css(classes.box)}>
          <span className={css(classes.closeIcon)} onClick={props.handleClose}>
            x
          </span>
          {props.content}
        </div>
      </div>
    )

    const pictures = [log.picture1, log.picture2, log.picture3].filter((p) => p)
    const isSignatureLog = log?.item?.itemId === 'signature'
    const nominative = getNominative(
      this.props.preferredPeopleNominative,
      'Service user'
    )

    return (
      <li style={styles.mainContainer} key={log.id} data-testid={baseId}>
        <LinkComponent
          disabled={isDisabled}
          to={`/logs/${log.id}`}
          className="lmc-timeline-link"
          data-testid={`${baseId}-link`}
        >
          <div style={styles.container}>
            <div style={styles.logRow}>
              <div data-testid={`${baseId}-icon`}>
                {this.renderIcon(log, this.props.isPDF)}
              </div>
              <div style={styles.logContent} data-testid={`${baseId}-content`}>
                {this.renderSubHeader(log, dateFormat)}
                <h3
                  style={{
                    ...styles.titleText,
                    color: isDeleted ? colors.darkgrey : null
                  }}
                  data-testid={`${baseId}-title`}
                >
                  {isDeleted ? `Log Removed` : log.title}
                </h3>
                <Description
                  isDeleted={isDeleted}
                  description={log.description}
                  testId={`${baseId}-description`}
                />
                {this.renderWitnessedBy(log)}
                {log.doneBySu && (
                  <span
                    className={css(classes.suInvolved)}
                    data-testid={`${baseId}-su-involved`}
                  >
                    {nominative} was involved in writing this log
                  </span>
                )}
              </div>
            </div>
          </div>
        </LinkComponent>
        <div
          style={{ marginLeft: 85, paddingBottom: 15 }}
          data-testid={`${baseId}-media`}
        >
          <GalleryWrapper data-testid={`${baseId}-gallery`}>
            <Gallery>
              {!isSignatureLog ? (
                pictures.map((url, idx) => (
                  <GalleryItem
                    key={url}
                    src={url}
                    alt="Log photo"
                    className={css(classes.picture)}
                    style={{
                      opacity,
                      display: this.props.isPDF ? 'none' : 'inline'
                    }}
                    width={749}
                    height={1000}
                    data-testid={`${baseId}-picture-${idx}`}
                  />
                ))
              ) : (
                <GalleryItem
                  key={log?.picture1}
                  src={log?.picture1 || ''}
                  alt="Signature log photo"
                  style={{
                    opacity,
                    height: '100px',
                    borderRadius: '10px',
                    marginTop: '8px',
                    marginRight: '8px',
                    background: '#f0f0f0',
                    cursor: 'pointer'
                  }}
                  width={749}
                  height={230}
                  data-testid={`${baseId}-signature-picture`}
                />
              )}
            </Gallery>
          </GalleryWrapper>
          {videoFile && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              className={css(classes.videoThumbnail)}
              onClick={(e) => {
                e.stopPropagation()
                this.toggleVideoPopup()
              }}
              style={{
                position: 'relative'
              }}
              data-testid={`${baseId}-video-thumbnail`}
            >
              <Icon
                name="play"
                fill={colors.white}
                size={32}
                style={{
                  position: 'absolute',
                  marginTop: 40,
                  marginLeft: 20
                }}
              />
              <img
                alt=""
                className={css(classes.videoThumbnail)}
                src={
                  videoThumbnail !== null
                    ? videoThumbnail
                    : videoThumbnailPlaceholder
                }
              />
            </a>
          )}

          {this.state.isVideoOpen && (
            <Popup
              content={
                <video controls className={css(classes.video)}>
                  <source src={videoFile} type="video/mp4" />
                  <track
                    src="captions_en.vtt"
                    kind="captions"
                    label="english_captions"
                  />
                </video>
              }
              handleClose={(e) => {
                this.toggleVideoPopup()
                e.stopPropagation()
              }}
            />
          )}
        </div>
      </li>
    )
  }
}

LogTimelineRow.propTypes = {
  index: PropTypes.number.isRequired,
  fixedPictures: PropTypes.bool,
  log: PropTypes.object.isRequired,
  total: PropTypes.number.isRequired,
  isPDF: PropTypes.bool,
  testId: PropTypes.string
}

const styles = {
  container: {
    padding: 12,
    paddingBottom: 0
  },
  picture: {
    height: 80,
    borderRadius: 10,
    marginTop: 8,
    marginRight: 8,
    background: colors.grey,
    cursor: 'pointer'
  },
  fixedPictures: {
    height: 80,
    borderRadius: 10,
    marginTop: 8,
    marginRight: 8
  },
  logContent: {},
  mainContainer: {
    background: colors.white,
    marginBottom: 12,
    borderRadius: 15
  },
  smallText: {
    color: colors.darkgrey,
    fontSize: 12
  },
  titleText: {
    fontWeight: 600,
    fontSize: 16,
    marginBottom: 0,
    lineHeight: '22px'
  },
  descriptionText: {
    fontSize: 14,
    color: colors.black
  },
  editedByText: {
    marginTop: 1,
    fontSize: 11,
    color: colors.darkgrey
  },
  logRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'left',
    margin: '0'
  },
  dot: {
    width: 44,
    height: 44,
    border: '3px solid rgba(0,0,0,0)',
    borderRadius: 24,
    backgroundColor: colors.grey,
    marginRight: 18,
    marginLeft: 12,
    marginTop: 6,
    alignItems: 'center'
  },
  iconStyle: {
    backgroundSize: '14px !important',
    backgroundPosition: 'center center !important'
  }
}

const classes = StyleSheet.create({
  description: {
    color: colors.black,
    display: 'block',
    marginTop: 2
  },
  icon: {
    width: 20
  },
  iconContainer: {
    alignItems: 'center',
    borderRadius: 46,
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    height: 46,
    marginRight: 12,
    width: 46
  },
  logContainer: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    lineHeight: 1.4,
    width: '55%'
  },
  logContainerNoLink: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: 1.4,
    width: '55%'
  },
  picture: {
    height: 100,
    borderRadius: 10,
    marginTop: 8,
    marginRight: 8,
    background: colors.background,
    cursor: 'pointer'
  },
  videoThumbnail: {
    height: 100,
    width: 75,
    borderRadius: 10,
    marginTop: 8,
    marginRight: 8,
    background: colors.background,
    cursor: 'pointer'
  },

  video: {
    width: '100%',
    maxHeight: '60vh',
    borderRadius: 10,
    background: colors.background,
    cursor: 'pointer'
  },
  loggedContainer: {
    display: 'flex'
  },
  smallText: {
    color: colors.darkgrey,
    display: 'block',
    fontSize: 12
  },
  smallText2: {
    color: colors.darkgrey
  },
  popupBox: {
    position: 'fixed',
    background: '#00000050',
    width: '100%',
    height: '100vh',
    top: '0',
    left: '0',
    zIndex: 10
  },
  box: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    width: '70%',
    margin: '0 auto',
    maxHeight: '70vh',
    marginTop: 'calc(100vh - 85vh - 20px)',
    background: colors.white,
    borderRadius: '10px',
    padding: '20px',
    overflow: 'auto'
  },
  iconPlay: {
    position: 'absolute',
    marginTop: 40,
    marginLeft: 20
  },
  closeIcon: {
    content: "'x'",
    cursor: 'pointer',
    position: 'fixed',
    right: 'calc(15% - 30px)',
    top: 'calc(100vh - 85vh - 33px)',
    background: colors.white,
    width: '25px',
    height: '25px',
    borderRadius: '50%',
    lineHeight: '20px',
    textAlign: 'center',
    fontSize: '20px'
  },
  title: {
    color: colors.black,
    display: 'block',
    fontWeight: 600
  },
  suInvolved: {
    color: '#595959',
    display: 'block',
    fontSize: '12px'
  }
})

const GalleryWrapper = styled.div`
  display: inline;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`

const mapStateToProps = (state) => ({
  role: state.global.user.role,
  preferredPeopleNominative: state.global.home.preferredPeopleNominative
})
export default connect(mapStateToProps, null)(LogTimelineRow)
